export default "__VITE_ASSET__CRglu5Qo__"